import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";

const usePotbelly = () => {
  const { themeContext, theme } = useTheme();
  const [potbellyCode, setPotbellyCode] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const {
    selectedLoyaltyData,
    checkPotbellyStatus,
    reservePotbellyCode,
    potbellyCodeGenerationMessage,
    setPotbellyCodeGenerationMessage,
    potbellyStatus,
    isProcessingPotbelly,
  } = useLoyalty();
  const { image, offerDescription, steps } = selectedLoyaltyData || {};
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  useEffect(() => {
    if (potbellyStatus === null) checkPotbellyStatus();
  }, []);

  useEffect(() => {
    if (potbellyStatus) {
      setPotbellyCode(potbellyStatus?.ticketCode);
    }
  }, [potbellyStatus]);

  useEffect(() => {
    if (potbellyCodeGenerationMessage) {
      setShowAlert(true);
    }
  }, [potbellyCodeGenerationMessage]);

  const hideAlert = () => {
    setShowAlert(false);
    setPotbellyCodeGenerationMessage(null);
  };

  return {
    background,
    history,
    bannerImage: image,
    offerDescription,
    potbellyStatus,
    potbellyCodeGenerationMessage,
    steps,
    reservePotbellyCode,
    potbellyCode,
    potbellyStatus,
    isProcessingPotbelly,
    showAlert,
    setShowAlert,
    hideAlert,
  };
};

export default usePotbelly;
